export const isEmpty = (obj) => {
    if (obj && typeof obj === 'object') {
        return Object.keys(obj).length === 0
    }
    return true
}
